<template>
  <section class="document-revisions">
    <loader-dots v-if="loadStatus" />
    
    <list-items-loadable
      v-else
      v-slot="{ item }"
      :items="revisionsItems"
      class="document-revisions__text"
      empty-text="Идёт загрузка редакций документа."
    >
      <div 
        v-if="item.kind == 'current'"
        class="document-revisions__item"
        :class="{ _current: true }"
      > 
        <div v-if="item.id != documentId">
          <router-link :to="makeDocumentRoute(item.id)"> {{item.name}} </router-link> 
        </div>  
        <div v-else>
          <div class="document-revisions__text" v-html="item.name"></div>
        </div> 

        <div class="document-revisions__text" v-html="item.annotation"></div>
      </div>
      <div 
        v-else-if="item.kind == 'future'"
        class="document-revisions__item"
        :class="{ _future: true }"
      >
        <div v-if="item.id != documentId">
          <router-link :to="makeDocumentRoute(item.id)"> {{item.name}} </router-link> 
        </div>  
        <div v-else>
          <div class="document-revisions__text" v-html="item.name"></div>
        </div> 

        <div class="document-revisions__text" v-html="item.annotation"></div>
      </div>
      <div 
        v-else
        class="document-revisions__item"
        :class="{ _prev: true }"
      >
        <div v-if="item.id != documentId">
          <router-link :to="makeDocumentRoute(item.id)"> {{item.name}} </router-link> 
        </div>  
        <div v-else>
          <div class="document-revisions__text" v-html="item.name"></div>
        </div>

        <div class="document-revisions__text" v-html="item.annotation"></div>
      </div>
    </list-items-loadable>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

import ListItemsLoadable from '@@/shared/list/ListItemsLoadable';
import LoaderDots from '@@/shared/loaders/LoaderDots';

import DocumentRoute from '@@/document/mixins/DocumentRoute';
import NormaCsLinkHandler from '@@/document/mixins/NormaCsLinkHandler';


export default {
  components: {
    ListItemsLoadable,
    LoaderDots
  },

  mixins: [NormaCsLinkHandler, DocumentRoute],

  props: {
    documentId: {
      type: String,
      required: true
    },
    loadStatus: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      revisionsItems: 'currentDocumentRevisions'
    })
  },

  mounted() {
    this.initNormaCsLinkHandler(this.$el);
  }

};
</script>
